import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { flex } from "shared/theme/mixins";

export const StyledTicketContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{ bgColor?: string }>`
  ${flex({ ai: "flex-start", jc: "space-between", fd: "column" })};
  padding: 1rem 1rem 1rem 0;
  width: calc(100% - 1rem);
  row-gap: 1rem;
  cursor: pointer;
  background-color: ${({ bgColor }) => bgColor};
`;

export const StyledTicketTitle = styled(Typography)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;
